import React from 'react'
import { Center } from '../../parts/bases/Center'
import SignUpLoginFrame from '../../../../public/images/signupLoginFrame.png'
import { VStack } from '../../parts/bases/VStack'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { Absolute } from '../../parts/bases/Absolute'
import { HStack } from '../../parts/bases/HStack'
import { PinkNeonButton } from '../../parts/buttons/PinkNeonButton'
import { Text } from '../../parts/bases/Text'
import { Space } from '../../parts/bases/Space'
import * as GlobalNavigationHeader from '../../parts/commons/GlobalNavigationHeader/Layout'
import { Head } from '../../parts/commons/Head'

export type Props = {
  onClickLoginButton: () => void
  onClickSignUpButton: () => void
  GlobalNavigationHeaderProps: GlobalNavigationHeader.Props
}

export const Layout = (props: Props) => {
  const { t } = useTranslation()
  return (
    <>
      <Head title="Welcome" />
      <VStack className="h-full w-full">
        <GlobalNavigationHeader.Layout {...props.GlobalNavigationHeaderProps} />
        <Center className="h-full w-full">
          <VStack className={`aspect-[2265/972] w-[700px]`}>
            <Image layout="fill" src={SignUpLoginFrame} alt="" />
            <Absolute className="top-0 left-0 h-full w-full">
              <VStack className="h-full w-full items-center justify-center p-12">
                <h1 className="text-2xl font-bold text-white">{t('WelcomePage.title')}</h1>
                <Space />
                <Text className="text-center text-neutral-500">{t('WelcomePage.message')}</Text>
                <Space />
                <HStack>
                  <PinkNeonButton onClick={props.onClickSignUpButton}>
                    <Text>{t('WelcomePage.signUpButton')}</Text>
                  </PinkNeonButton>
                  <VStack className="w-6" />
                  <PinkNeonButton onClick={props.onClickLoginButton}>
                    <Text>{t('WelcomePage.loginButton')}</Text>
                  </PinkNeonButton>
                </HStack>
              </VStack>
            </Absolute>
          </VStack>
        </Center>
      </VStack>
    </>
  )
}
